
  import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {Chart} from 'chart.js';
  import {Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {DoctorService} from '../../../../services/doctor.service';
  import {MatDialog} from '@angular/material/dialog';
  import {Observable, Subscription} from 'rxjs';
  import {MatTableDataSource} from '@angular/material/table';
  import {Patient} from '../../../../model/user/Patient';
  import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
  import {MatCheckboxChange} from '@angular/material/checkbox';
  import {MatSnackBar} from "@angular/material/snack-bar";
  import { FormControl, FormGroup } from '@angular/forms';
  

@Component({
  selector: 'app-bar-chart-never-logged-age-from-user',
  templateUrl: './bar-chart-never-logged-age-from-user.component.html',
  styleUrls: ['./bar-chart-never-logged-age-from-user.component.css']
})
export class BarChartNeverLoggedAgeFromUserComponent implements OnInit {
    
    numberFormAge = new FormGroup({
      from: new FormControl(''),
      to: new FormControl(''),
    });
    
            // per inizializzazione
            getAuthState: Observable<any>;
            getDoctorState: Observable<any>;
            isAuthenticated: boolean;
            user = null;
            errorMessage = null;
            subscription1: Subscription;
            subscription5: Subscription;
            subscription6: Subscription;
            title = "Fascia d'età";
            destination = 'never-logged';
  
            // elementi che servono per il bar-chart
            canvas: any;
            ctx: any;
            myChartNeverLoggedPatients: Chart;
      
            // ******************************************************************************************************************
            // seguenti righe: inizializzazione dei pazienti 
            // ******************************************************************************************************************
            neverLoggedGlobalFasciaA = 0;      
            loggedGlobalFasciaA = 0;
            GlobalPatientsFasciaA = 0;    
      
            neverLoggedGlobalPatientsArray = [];
            loggedGlobalPatientsArray = [];
            neverLoggedPatientsGlobal = [];
            // ******************************************************************************************************************
            // bar chart dei pazienti 
            // ******************************************************************************************************************
            public barChartLabelsGlobalNeverLogged = ['Fascia'];
            public barChartTypeGlobalNeverLogged = 'horizontalBar';
            public barChartLegendGlobalNeverLogged = true;
            public barChartDataGlobalNeverLogged = [
              {
                data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal'],
                hoverBackgroundColor: ['#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
              },
              {
                data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered'],
                hoverBackgroundColor: ['#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
              }];
            
      
      
            // constructor
            constructor(private store: Store<AppState>,
                        private doctorService: DoctorService,
                        private snackBar: MatSnackBar) {
              this.getAuthState = this.store.select(selectAuthState);
              this.getDoctorState = this.store.select(selectDoctorState);
            }
            // ******************************************************************************************************************
            // metodo all'inizio
            ngOnInit(): void {
              this.subscription6 = this.getAuthState.subscribe((state) => {
                this.isAuthenticated = state.isAuthenticated;
                this.user = JSON.parse(localStorage.getItem('user'));
                this.errorMessage = state.errorMessage;
              });
            }

            ngOnDestroy(): void {
              this.subscription1.unsubscribe();
              this.subscription5.unsubscribe();
              this.subscription6.unsubscribe();
            }

            clearData() {
              this.neverLoggedGlobalFasciaA = 0;      
                this.loggedGlobalFasciaA = 0;
                this.GlobalPatientsFasciaA = 0;    
      
                this.neverLoggedGlobalPatientsArray = [];
                this.loggedGlobalPatientsArray = [];
                this.neverLoggedPatientsGlobal = [];

                this.myChartNeverLoggedPatients.clear();
                this.myChartNeverLoggedPatients.destroy();
                this.canvas =null;
                this.ctx = null;
              this.barChartDataGlobalNeverLogged=[
                {
                  data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal'],
                  hoverBackgroundColor: ['#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
                },
                {
                  data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered'],
                  hoverBackgroundColor: ['#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
                }];
            }
            // ******************************************************************************************************************
            // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
            // e in standard e poi tutti
            // i pazienti in ogni categoria per poter calcolare gli attivi
            // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart

            onSubmitAgeForm() {
              if(this.myChartNeverLoggedPatients!=null)              
                this.clearData(); 
              this.retrieveGlobalNeverLoggedFromUtente(this.numberFormAge.get('from').value,this.numberFormAge.get('to').value);
            }
            
            retrieveGlobalNeverLoggedFromUtente(from,to) {
              this.subscription1 = this.doctorService.getNeverLoggedAgeBracketsNumber(from,to).subscribe(npatients => {
                this.neverLoggedGlobalFasciaA = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalFasciaA); // riempio il vettore del bar chart con standard
                this.retrieveGlobalAge(from,to);
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
  
            retrieveGlobalAge(from,to) {
              this.subscription5 = this.doctorService.getGlobalAgeFromUserNumber(from,to).subscribe(num => {
                this.GlobalPatientsFasciaA = num[0];
                this.loggedGlobalFasciaA = this.GlobalPatientsFasciaA - this.neverLoggedGlobalFasciaA;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalFasciaA); // riempio il vettore del bar chart con standard           
                /*console.log(this.GlobalPatientsFasciaA);
                console.log(this.loggedGlobalFasciaA);
                console.log(this.neverLoggedGlobalFasciaA);
                console.log(this.barChartDataGlobalNeverLogged);*/
                this.canvasSetting();
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
           
            canvasSetting() {

                this.canvas = document.getElementById('myChartNeverLoggedAgeFromUser') as HTMLCanvasElement;
                this.ctx = this.canvas.getContext('2d');
                this.myChartNeverLoggedPatients = new Chart(this.ctx, {
                  type: this.barChartTypeGlobalNeverLogged,
                  data: {
                    labels: this.barChartLabelsGlobalNeverLogged,
                    datasets: this.barChartDataGlobalNeverLogged,
                  },
                  options: {
                    maintainAspectRatio: true,
                    responsive: true,
      
                    scales: {
                      xAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                    },
                    legend: {
                     
                      display: true,
                      position: 'top',
                      labels: {
                        usePointStyle: true,
                        fontColor: '#006192',
                        fontSize: 18,
                        fontFamily: 'Helvetica',
                      }
                    },
                    tooltips: {
                      // content: '{pathology}: {number}',
                      backgroundColor: '#1c1c1c',
                      bodyFontSize: 18,
                      titleFontSize: 18,
                      cornerRadius: 5,
                      caretPadding: 10
                    },
                    title: {
                      display: true,
                      text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                      fontColor: '#006192',
                      fontSize: 20,
                      fontFamily: 'Helvetica',
                    },
                    hover: {
                      mode: 'nearest',
                      intersect: true
                    }
                  }
                });
                } // dopo aver ottenuto tutti i dati creo il bar chart
            
          }
          
